export function sliceArrayBySize(array: unknown[], size: number) {
  let subarray = [];

  for (let i = 0; i < Math.ceil(array.length / size); i++) {
    subarray[i] = array.slice(i * size, i * size + size);
  }

  return subarray;
}

export function createMaskForCardNumber(cardNumber: string) {
  const cardSlices = sliceArrayBySize(Array.from(cardNumber), 4);
  let resultString = "";

  const cardSlicesWithStrings = cardSlices.map((item) => {
    let newStringSlice = "";
    for (let i = 0; i <= item.length - 1; i++) {
      newStringSlice += item[i];
    }
    return newStringSlice;
  });

  cardSlicesWithStrings?.forEach((item, index) => {
    resultString +=
      index !== cardSlicesWithStrings.length - 1 ? `${item} ` : `${item}`;
  });
  return resultString;
}
